import { useState } from 'react';
import { AdminPage } from './AdminPage';
import { InstitutionsPage } from './InstitutionsPage';
import { TemplatesPage } from './TemplatesPage';
import { SupportAccessPage } from './SupportAccessPage';

type Tab = 'staff' | 'campuses' | 'templates' | 'support';

const TABS: { id: Tab; label: string }[] = [
  { id: 'staff', label: 'Staff & access' },
  { id: 'campuses', label: 'Campuses & institutions' },
  { id: 'templates', label: 'Notification templates' },
  { id: 'support', label: 'Support access' },
];

/// <summary>
/// The unified school-admin console. Consolidates the previously-scattered admin pages (staff,
/// campuses, templates) under one route with tabs. Grading configs deliberately stay on the
/// Exams page, co-located with mark entry and results where they are actually used.
/// </summary>
export function AdminConsole() {
  const [tab, setTab] = useState<Tab>('staff');

  return (
    <div>
      <div style={{ marginBottom: 20 }}>
        <div className="eyebrow" style={{ marginBottom: 6 }}>Admin</div>
        <h1 className="h-display" style={{ fontSize: 28 }}>School administration</h1>
        <p style={{ color: 'var(--ink-2)', marginTop: 4, maxWidth: 640 }}>
          Manage the people, structure, and settings for your school in one place. Grading rules
          live with the exams they apply to, on the Exams page.
        </p>
      </div>

      <div className="tab-strip" style={{ gap: 6, marginBottom: 24, flexWrap: 'wrap' }}>
        {TABS.map((t) => (
          <button key={t.id} onClick={() => setTab(t.id)} className="btn" style={{
            padding: '9px 16px', borderRadius: '8px 8px 0 0', border: 'none',
            borderBottom: tab === t.id ? '2px solid var(--brand)' : '2px solid transparent',
            background: 'transparent', color: tab === t.id ? 'var(--brand)' : 'var(--ink-2)',
            fontWeight: tab === t.id ? 600 : 500, marginBottom: -1,
          }}>{t.label}</button>
        ))}
      </div>

      {tab === 'staff' && <AdminPage embedded />}
      {tab === 'campuses' && <InstitutionsPage embedded />}
      {tab === 'templates' && <TemplatesPage embedded />}
      {tab === 'support' && <SupportAccessPage embedded />}
    </div>
  );
}
